/**
 * creatorPromptInspector.ts
 *
 * Lightweight reactive bus for capturing creator relay request payloads.
 * Enabled in dev builds or when ?inspect is present in the URL.
 *
 * TO REMOVE THIS FEATURE:
 *   1. Delete this file (app/src/dev/creatorPromptInspector.ts)
 *   2. Delete app/src/components/dev/CreatorPromptInspectorPanel.vue
 *   3. Remove the import + recordPromptDispatch() call from app/src/api/adapters/relay.ts
 *   4. Remove the import + <CreatorPromptInspectorPanel /> from app/src/views/creation/CreatorSessionView.vue
 */

import { ref, shallowReactive } from 'vue'

export interface PromptDispatchRecord {
  id: string
  timestamp: number
  /** structuredClone snapshot of the relay request body */
  body: unknown
  endpoint: string
}

const MAX_RECORDS = 25

export const promptDispatches = shallowReactive<PromptDispatchRecord[]>([])

export const inspectorEnabled = ref<boolean>(
  typeof window !== 'undefined' &&
    (import.meta.env?.DEV === true ||
      new URLSearchParams(window.location.search).has('inspect')),
)

export function recordPromptDispatch(body: unknown, endpoint: string): void {
  if (!inspectorEnabled.value) return

  let snapshot: unknown
  try {
    snapshot = structuredClone(body)
  } catch {
    snapshot = JSON.parse(JSON.stringify(body))
  }

  promptDispatches.unshift({
    id: crypto?.randomUUID?.() ?? String(Date.now() + Math.random()),
    timestamp: Date.now(),
    body: snapshot,
    endpoint,
  })

  if (promptDispatches.length > MAX_RECORDS) {
    promptDispatches.length = MAX_RECORDS
  }
}

export function clearPromptDispatches(): void {
  promptDispatches.length = 0
}
